import { colors } from '../../theme/colors';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import North from '@mui/icons-material/North';
import South from '@mui/icons-material/South';
import TrendingFlat from '@mui/icons-material/TrendingFlat';
import type { Theme } from '@mui/material/styles';

// metricText rather than text: semantic.text.success (success[500]) is a shade
// lighter than this tile's Figma spec, which calls out success[600] - exactly
// what metricText.success is, in both light and dark mode. The same token the
// other dashboard tiles use for their metric figures.
const upColor = (theme: Theme) => theme.palette.semantic.metricText.success;

// Figma's "Recent Admin Actions Sizes" note (node 5467:15216) calls for #F27070
// - error[400] - on the down trend. No semantic token resolves to it in both
// modes (text.error2 does in dark mode only), so it's taken from the palette
// directly; as a light red it stays legible on the dark surface too.
const DOWN_COLOR = colors.error[400];

interface RecentAdminActionsTrendProps {
  todayCount: number;
  yesterdayCount: number;
}

export default function RecentAdminActionsTrend({
  todayCount,
  yesterdayCount,
}: RecentAdminActionsTrendProps) {
  if (yesterdayCount === 0) {
    if (todayCount === 0) return null;
    return (
      <Stack direction="row" spacing={0.5} alignItems="center">
        <North sx={{ color: upColor }} />
        <Typography variant="body2" sx={{ color: upColor }}>
          New
        </Typography>
      </Stack>
    );
  }

  const percentChange = Math.round(
    ((todayCount - yesterdayCount) / yesterdayCount) * 100
  );

  if (percentChange === 0) {
    return (
      <Stack direction="row" spacing={0.5} alignItems="center">
        <TrendingFlat
          sx={{ color: (theme) => theme.palette.semantic.text.secondary }}
        />
        <Typography
          variant="body2"
          sx={{ color: (theme) => theme.palette.semantic.text.secondary }}
        >
          No change
        </Typography>
      </Stack>
    );
  }

  const isUp = percentChange > 0;
  const color = isUp ? upColor : DOWN_COLOR;

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      {isUp ? <North sx={{ color }} /> : <South sx={{ color }} />}
      <Typography variant="body2" sx={{ color }}>
        {isUp ? 'Up' : 'Down'} by {Math.abs(percentChange)}%
      </Typography>
    </Stack>
  );
}
